import React from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Mobile-only sticky pill nav for jumping back to homepage sections.
 * Used on the homepage (in-page anchor scrolling) and on user-facing
 * subpages (navigates to homepage + anchor). Hidden on `md+`.
 */
const SECTIONS = [
  { hash: 'preco-t9', label: 'Prečo EduMisia?' },
  { hash: 'ako-funguje', label: 'Ako to funguje?' },
  { hash: 'co-ponukame', label: 'Čo ponúkame?' },
  { hash: 'cennik', label: 'Cenník' },
  { hash: 'faq', label: 'Časté otázky' },
]

const SectionNavPills = () => {
  const { pathname } = useLocation()
  const onHome = pathname === '/'

  // On the homepage use a bare hash to keep in-page scroll behaviour
  // (no full reload). On subpages use "/#anchor" which navigates to the
  // homepage and the browser handles the hash scroll.
  const hrefFor = (hash) => (onHome ? `#${hash}` : `/#${hash}`)

  return (
    <div
      className="md:hidden sticky top-16 z-30 border-b border-slate-200 bg-white/90 backdrop-blur-md shadow-sm"
      data-testid="section-nav-pills"
    >
      <nav
        className="flex items-center gap-1.5 px-4 py-2.5 overflow-x-auto scrollbar-hide"
        aria-label="Navigácia po sekciách"
      >
        {SECTIONS.map((s) => (
          <a
            key={s.hash}
            href={hrefFor(s.hash)}
            className="flex-shrink-0 inline-flex items-center px-3 py-1.5 rounded-full bg-slate-50 text-slate-700 ring-1 ring-slate-200 hover:bg-blue-50 hover:text-blue-700 hover:ring-blue-200 active:bg-blue-100 text-xs font-medium transition-colors whitespace-nowrap"
          >
            {s.label}
          </a>
        ))}
      </nav>
    </div>
  )
}

export default SectionNavPills
